export default __webpack_public_path__ + "static/media/slide_alianzas_mobile.39b47961.png";